const ContactData = [
    {
        key: "footer-contact",
        heading: "CONTACT",
        title: "ABHINAV CHOUDHARY",
        phone: "+1 (857)746-1424",
        email: "Abhinav.Choudhary1106@gmail.com",
        links: [
            {
                key:"linkedIn",
                title: "LinkedIn",
                href: "https://www.linkedin.com/in/choudhary-abhinav/",
                className: "linkedin-logo",
                isIcon: false,
                text: "in"
            },
            {
                key:"twitter",
                title: "Twitter",
                href: "https://twitter.com/IamAbvChoudhary",
                className: "gg-twitter twitter-logo",
                isIcon: true
            },
            {
                key:"instagram",
                title: "Instagram",
                href: "https://www.instagram.com/choudhary.abhinav/",
                className: "gg-instagram instagram-logo",
                isIcon: true
            },
            {
                key:"github",
                title: "Github",
                href: "https://github.com/Abhinav-Choudhary",
                className: "gg-git-fork github-logo",
                isIcon: true
            }
        ]
    }
];

export default ContactData;